exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".services-detail img {\n  border-radius: 20px 20px 20px 20px;\n  -moz-border-radius: 20px 20px 20px 20px;\n  -webkit-border-radius: 20px 20px 20px 20px;\n  -o-border-radius: 20px 20px 20px 20px;\n  -webkit-appearance: none;\n  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.18);\n}\n.services-detail h1 {\n  margin-bottom: 80px;\n}\n.services-detail h2 {\n  color: #44414a;\n  font-size: 25px;\n  font-weight: 700;\n  margin: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/services/services-details/services-details.component.less
// module id = ../../../../../src/app/services/services-details/services-details.component.less
// module chunks = main